import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import CircularProgress from '@mui/material/CircularProgress';
import moment from 'moment';
import { fetchHistoryById } from '../reducers/HistorySlice';
import { useReactToPrint } from "react-to-print";

const ViewHistory = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { history, status, error } = useSelector(state => state.histories);

    const printRef = useRef();

    const handlePrint = useReactToPrint({
        contentRef: printRef,            // <-- v3: use this
        documentTitle: "Student Report",
        onAfterPrint: () => console.log("Printed!"),
    });

    useEffect(() => {
        if (id) {
            dispatch(fetchHistoryById(id));
        }
    }, [id, dispatch]);

    if (status === 'loading') {
        return <div className="d-flex justify-content-center align-items-center h-100"><CircularProgress /></div>;
    }

    if (status === 'failed') {
        return <div>Failed to load History data: {error}</div>;
    }

    if (!history) {
        return <div>No History data available.</div>;
    }

    return (
        <>
            <div className="container my-4 text-white view-student">
                <div className="row" id="studentContainer">
                    <div className="col">
                        <div className="card-body">
                            <div className="card student-card p-4">
                                <div className="overflow-x-auto bg-white">
                                    <div ref={printRef}>
                                        <table className="table-auto table-color w-100 border border-gray-300 shadow-md rounded-lg">
                                            <h2 className='text-center mb-2'>AK Boys Hostel</h2>
                                            <tbody>
                                                {[
                                                    ["Month", history?.month, "History ID", history?._id],
                                                    ["Students", history?.students, "Bookings", history?.bookings],
                                                    ["Staff", history?.staff, "Workers", history?.workers],
                                                    ["Staff Salary", history?.staffSalary?.toLocaleString(), "Worker Salary", history?.workerSalary?.toLocaleString()],
                                                    ["Total Salary", history?.totalSalary?.toLocaleString(), "Maintenance Cost", history?.maintenanceCost?.toLocaleString()],
                                                    ["Security Charges", history?.securityCharges?.toLocaleString(), "Paid Amount", history?.paidAmount?.toLocaleString()],
                                                    ["Received Amount", history?.receivedAmount?.toLocaleString(), "Electricity Bill", history?.electricityBill?.toLocaleString()],
                                                    ["Water Bill", history?.waterBill?.toLocaleString(), "Gas Bill", history?.gasBill?.toLocaleString()],
                                                    ["Internet Bill", history?.internetBill?.toLocaleString(), "Other Bills", history?.otherBills?.toLocaleString()],
                                                    ["Created At", moment(history?.createdAt).format("DD-MM-YYYY"), "Updated At", moment(history?.updatedAt).format("DD-MM-YYYY")]
                                                ].map((row, rowIndex) => (
                                                    <tr key={rowIndex} className="border-b border-gray-300">
                                                        {row.map((cell, cellIndex) => (
                                                            <td key={cellIndex} className="px-4 py-2 border border-gray-300">
                                                                <strong>{cellIndex % 2 === 0 ? cell : ""}</strong> {cellIndex % 2 !== 0 ? cell : ""}
                                                            </td>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <button className="btn btn-primary" onClick={handlePrint}>Print Report</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <style>
                {`
      @media print {
       
      }
    `}
            </style>
        </>
    );
}

export default ViewHistory;
